// "Routines" tab of the agent drawer (SPEC-UX-V03 §B): every routine of the agent with the shared
// list of AUTOMATISATIONS (automations/routinelist.js) — create (the agent locked in the editor),
// edit, pause / resume, run now, delete after confirmation, live events. The editors opened here
// close with the drawer (the list is destroyed with it).
import { h, button } from '../../dom.js';
import { t } from '../../i18n/fr.js';
import { createRoutineList } from '../automations/routinelist.js';
import './strings.js';

/**
 * Builds the tab.
 * @param {object} ctx app context
 * @param {object} agent {id, name}
 * @param {{routines: object}} opts routines: the drawer's routine source
 * @returns {{el: HTMLElement, activate(): void, deactivate(): void, destroy(): void, create(): void}}
 */
export function createRoutinesTab(ctx, agent, { routines }) {
  const newBtn = button(t('ad.ov.newRoutine'), { variant: 'primary', size: 'sm', icon: 'plus', class: 'ad-rt-new', onClick: () => list.create() });
  let list = null;
  list = createRoutineList(ctx, { agentId: agent.id, source: routines, onChange: (l) => { newBtn.hidden = !l.canCreate(); } });
  const calendarBtn = button(t('auto.calendar'), { variant: 'ghost', size: 'sm', icon: 'calendar', onClick: () => ctx.navigate('#/calendar') });
  const intro = h('p', { class: 'ad-rt-intro muted' }, t('ad.rt.intro', { name: agent.name }));
  const el = h('div', { class: 'ad-routines' },
    h('div', { class: 'ad-rt-bar' }, intro, h('span', { class: 'spacer' }), calendarBtn, newBtn),
    list.el);

  return {
    el,
    activate() { list.render(); },
    deactivate() {},
    create: () => list.create(),
    destroy() { list.destroy(); },
  };
}
